<template>

  <div class="kt-portlet kt-portlet--mobile">
    <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->
    <!--begin::Form-->
    <form class="kt-form" ref="form">
      <div class="kt-portlet__head kt-portlet__head--lg">
        <div class="kt-portlet__head-label">
          <span class="kt-portlet__head-icon">
            <i class="kt-font-brand flaticon-home"></i>
          </span>
          <h3 class="kt-portlet__head-title">{{this.$route.meta.breadcrumb}}</h3>
        </div>
      </div>
      <div class="kt-portlet__body">
        <div class="kt-section kt-section--first">
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label">ชื่อหมวดหมู่ :</label>
                <span class="form-control-plaintext">{{delFolderName}}</span>
              </div>
            </div>

            <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label">ผู้สร้าง :</label>
                <span class="form-control-plaintext">{{delCreateBy}}</span>
              </div>
            </div>

            <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label">วันที่สร้าง :</label>
                <span class="form-control-plaintext">{{delCreateDate}}</span>
              </div>
            </div>
          </div>
          <!-- Begin: status checkbox -->
            <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
              <div class="form-group">
                <label>สถานะ:</label>
                <div class="form-check">
                  <label class="form-check-label kt-checkbox">
                    <input 
                      id="buStatus"
                      name="buStatus"
                      v-model="delStatus"
                      type="checkbox"
                      class="form-check-input"
                      disabled
                    />
                    เปิดใช้งาน
                    <span></span>
                  </label>
                </div>
              </div>
            </div>
            <!-- End: status checkbox -->

          <div class="row mb-3">
              <div class="col-xl-12">
                <button
                  type="button"
                  class="btn btn-outline-brand btn-sm"
                  @click.prevent="AddSub"
                >
                  <i class="fa fa-plus-circle">เพิ่มหมวดหมู่ย่อย</i>
                </button>
                <!-- <router-link
                  to="E-Learning/AddSubFolder"
                  tag="button"
                  title="เพิ่ม"
                  class="btn btn-outline-brand"
                  v-if="this.$root.canShow([''])"
                  >
                    <i class="fa fa-plus-circle"></i> เพิ่มหมวดหมู่ย่อย
                  </router-link> -->
              </div>
            </div>

          <div class="kt-section kt-section--first">
            <h3 class="kt-section__title">รายการ:</h3>
            <div class="kt-section__body">
              <div class="row">
                <div class="col-sm-12 table-responsive">
                  <table
                    class="table table-sm table-striped table-bordered table-hover table-checkable"
                  >
                    <thead>
                      <tr>
                        <th class="text-center" width="5%">ลำดับ</th>
                        <th class="text-center" width="20%">ชื่อ</th>
                        <th class="text-center" width="7%">วันที่สร้าง</th>
                        <th class="text-center" width="15%">การจัดการ</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(row, i) in delItems" :key="i">
                        <td class="text-center ">{{i + 1}}</td>
                        <td v-if="row.isItemFile === false" class="">
                          <router-link :to='`/5S/E-Learning/Detials/${row.folderAndFileId}`' @click.native="$router.go()">{{ row.folderAndFileName}}</router-link>
                          <!-- <a :href="$router.resolve({name: '/5S/E-Learning/Detials/'+row.folderAndFileId}).href">link</a> -->
                          <!-- <a href="#" @click.prevent="FolderClick(row.folderAndFileId)">
                          {{ row.folderAndFileName}}</a> -->
                          <!-- <router-link :to="`/5S/E-Learning/Detials/${row.folderAndFileId}`">{{ row.folderAndFileName}}</router-link> -->
                        </td>
                        <td v-else>No I'm Folder</td>
                        <td class="text-center ">{{row.createdDateFormat}}</td>
                        <td class="text-center ">{{row.quotaName}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="kt-portlet__foot">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="$router.go(-1)"
        >
          <i class="la la-close"></i> ย้อนกลับ
        </button>
      </div>
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";

export default {
  data() {
    var self = this;
    return {
      delFolderName: null,
      delFolderId: null,
      delCreateDate: null,
      delCreateBy: null,
      delStatus:false,
      delItems: []
    };
  },
  methods :{
    FolderClick :  function(id){
      let router = this.$router;
      // router.push({
      //   path: `/5S/E-Learning/Detials/${id}`
      // });
      this.$router.go(`/5S/E-Learning/Detials/${id}`)
    },
    AddSub() {
      let router = this.$router;
      let self = this;
      router.push({
        path: `/5S/E-Learning/Detials/${self.delFolderId}/AddSubFolder`
      });
    }
  },
  async mounted() {
    let self = this;
    let router = this.$router;
    let user = await this.$root.getUser();

    KTApp.blockPage({
      opacity: 0.05,
      message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
    });

    axios
      .get("/Api/Folder/" + this.$route.params.id)
      .then(function(response) {
        if (response.status == 200) {
          console.log(response.data);
          //console.log(response.data);
          if (response.data != null) {
            
            self.delFolderName = response.data.folderName;
            self.delFolderId = response.data.folderElearningId;
            self.delCreateDate = response.data.createdDateFormat;
            self.delCreateBy = response.data.createdBy;
            self.delItems = response.data.itemsCombine;
            self.delStatus = !response.data.inActiveStatus;
            // // self.ordDownloadUrl =
            // //   "/Api/DownloadFile/Byte?" + response.data[0].downloadUrl;
            // if (response.data[0].downloadUrl) {
            //   self.ordDownloadUrl =
            //     "/Api/DownloadFile/Byte?" + response.data[0].downloadUrl;
            // }
            // self.ordStocks = response.data;
          }
        } else {
          Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลสินค้าคุณเลือก", "warning");
          router.go(-1);
        }
      })
      .catch(function(error) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลสินค้าได้ในขณะนี้",
          "error"
        );
        router.go(-1);
      })
      .then(function() {
        // always executed
        KTApp.unblockPage();
      });
  }
};
</script>
<style lang="css">
.stock-item-td {
  color: #6c7293;
}
</style>


// WEBPACK FOOTER //
// App/Components/5S/UpdateELearning.vue